import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { Button, Input, Table, Typography } from "antd";
import { carpetByRef, clientName, dimensionsText, findClient } from "../../mocks/carpets";
import CleanStatus from "./CleanStatus";
import { useCarpetPreview } from "./context";

const { Title } = Typography;

export default function CheckOut() {
  const intl = useIntl();
  const history = useHistory();
  const { state, openStayFor, checkOut } = useCarpetPreview();
  const [ref, setRef] = useState("");
  const [lines, setLines] = useState([]);
  const [error, setError] = useState(null);

  const add = () => {
    const carpet = carpetByRef(state, ref);
    if (!carpet || !openStayFor(carpet.id)) {
      setError("notInShop");
      return;
    }
    if (lines.some((line) => line.id === carpet.id)) {
      setError("duplicateRef");
      return;
    }
    setLines((current) => current.concat({ ...carpet, outNotes: "" }));
    setRef("");
    setError(null);
  };

  const submit = () => {
    if (!lines.length) return;
    const missing = lines.filter((carpet) => !openStayFor(carpet.id));
    if (missing.length) {
      setError("notInShop");
      return;
    }
    const bundle = checkOut(lines.map((carpet) => ({ carpetId: carpet.id, outNotes: carpet.outNotes })));
    history.push({ pathname: "/preview/report", state: { stayIds: bundle.stays.map((stay) => stay.id), bundle } });
  };

  return (
    <div>
      <Title level={4} style={{ marginTop: 0 }}>{intl.formatMessage({ id: "checkOut" })}</Title>
      <div className="no-print" style={{ display: "flex", gap: 8, marginBottom: 12 }}>
        <Input
          value={ref}
          placeholder={intl.formatMessage({ id: "ref" })}
          style={{ width: 120 }}
          onChange={(event) => setRef(event.target.value)}
          onPressEnter={add}
        />
        <Button onClick={add}>{intl.formatMessage({ id: "add" })}</Button>
        {error && <span style={{ color: "#cf1322", lineHeight: "32px" }}>{intl.formatMessage({ id: error })}</span>}
      </div>
      <Table
        size="small"
        bordered
        pagination={false}
        rowKey="id"
        dataSource={lines}
        columns={[
          { title: intl.formatMessage({ id: "ref" }), dataIndex: "ref", width: 80 },
          {
            title: intl.formatMessage({ id: "client" }),
            render: (carpet) => clientName(findClient(state, carpet.clientId)),
          },
          { title: intl.formatMessage({ id: "category" }), render: (carpet) => intl.formatMessage({ id: carpet.category }) },
          { title: intl.formatMessage({ id: "widthXLength" }), render: (carpet) => dimensionsText(carpet) },
          {
            title: intl.formatMessage({ id: "cleanStatus" }),
            width: 110,
            render: (carpet) => {
              const stay = openStayFor(carpet.id);
              if (!stay) return null;
              return <CleanStatus cleaned={stay.cleaned} />;
            },
          },
          {
            title: intl.formatMessage({ id: "outNotes" }),
            width: 200,
            render: (carpet) => (
              <Input
                size="small"
                value={carpet.outNotes}
                onChange={(event) => {
                  const value = event.target.value;
                  setLines((current) => current.map((item) => (item.id === carpet.id ? { ...item, outNotes: value } : item)));
                }}
              />
            ),
          },
          {
            title: "",
            width: 80,
            render: (carpet) => (
              <Button type="link" onClick={() => setLines((current) => current.filter((item) => item.id !== carpet.id))}>
                {intl.formatMessage({ id: "remove" })}
              </Button>
            ),
          },
        ]}
      />
      <Button className="no-print" type="primary" style={{ marginTop: 12 }} onClick={submit} disabled={!lines.length}>
        {intl.formatMessage({ id: "checkOut" })}
      </Button>
    </div>
  );
}
